import { service } from './service'

import { config } from './config'

import qs from 'qs'
import { useAuthStoreWithOut } from '@/store/modules/auth'

const authStore = useAuthStoreWithOut()
const { default_headers } = config
const DOMAIN_KEY = 'portal'
export function getBaseURL (baseUrl) {
  if ((window as any).$assetorigin.search(DOMAIN_KEY) !== -1) {
    let url = (window as any).$assetorigin
    const reg = new RegExp('-\\d+-\\d+-\\d+')
    url = url.replace(reg, '')
    const key = 'portal-asset'
    let replaceStr = 'portal-apm', joinStr = ''
    switch (baseUrl) {
      case 'm2i':
        replaceStr = 'api-m2i'
        joinStr = 'm2i'
        break;
      case 'apm-dis':
          replaceStr = 'apm-dis'
          break;
      case 'msgpush':
        replaceStr = 'messagepush'
        joinStr = ''
        break;
      case 'portal-apm':
        replaceStr = 'portal-apm'
        break;
      case 'api-pi':
        replaceStr = 'api-pi'
        break;
      default:
        break;
    }
    url = `${url.replace(key, replaceStr)}${joinStr}`
    return url
  }  
  return baseUrl
}

const request = (option: any) => {
  // console.log('option',option)
  const { url, method, params, data, headersType, responseType,baseUrl,header } = option
  const headers = header?header:{}
  if (!headers['org-id']) {
    let orgId = authStore.getOrgInfo.id
    if ((window as any).$wujie) orgId = (window as any).$wujie.props.orgInfo.id
    headers['org-id'] = orgId
  }
  if (process.env.NODE_ENV !== 'production') {
    if(url&&(url.indexOf('/api-apm/')==0 || url.indexOf('/apm-push/')==0)){
      // headers['Tenant-Id'] = 'cluster01a99c5e30-006b-11eb-8201-00d8613dec81m2idemo'
      headers['Tenant-Id'] = '9eac64c330a5457a8f20b88f7279029b'
    }
  }
  
  return service({
    baseURL: getBaseURL(baseUrl),
    url: url,
    method,
    params,
    data,
    responseType: responseType,
    withCredentials: true,
    headers: {
      'Content-Type': headersType || default_headers,
      ...headers
    },
    paramsSerializer : params => {
      return qs.stringify(params, { indices: false })
    }  
  })
}
export default {
  get: <T = any>(option: any) => {
    return request({ method: 'get', ...option }) as unknown as T
  },
  post: <T = any>(option: any) => {
    return request({ method: 'post', ...option }) as unknown as T
  },
  delete: <T = any>(option: any) => {
    return request({ method: 'delete', ...option }) as unknown as T
  },
  put: <T = any>(option: any) => {
    return request({ method: 'put', ...option }) as unknown as T
  }
}
